var placeholderInit;

(function ($) {

	const selectors = {
		wrap: '[data-placeholder]',
		input: '[data-placeholder-input]',
	}

	placeholderInit = function () {

		$(selectors.wrap).each((i, el) => {
			new Placeholder(el);
		});

	}

	class Placeholder {

		constructor(el) {

			this.$wrap = $(el);

			if (this.$wrap.length) {
				this.init();
				this.bind();
			}
		}

		init() {
			this.$input = $(selectors.input, this.$wrap);
			this.change();

		}
		bind() {
			// const self = this;
			this.change = this.change.bind(this);
			this.$input.on('change', (e) => { this.change(); });
		}

		change(el) {

			var val = '';

			if (this.$input.is('select')) {
				val = this.$input.find(':selected').text();
			}
			else {
				val = this.$input.val();
			}

			if (val) {
				this.$wrap.addClass('has-val');
			}
			else {
				this.$input.trigger('blur');
				this.$wrap.removeClass('has-val');

			}

		}

	}

})(jQuery);


export default placeholderInit;